export enum FileManagementCategories {
    HealthDocumentInternal = 'HealthDocumentInternal',
    HealthDocumentExternal = 'HealthDocumentExternal'
}
